import React from 'react';
import { useTranslation } from 'react-i18next';

const VerifyResult: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        CRC Verification
      </h3>
      <div className="text-sm text-gray-400">
        <p>{t('flash.result.expectedCRC')}: --</p>
        <p>{t('flash.result.actualCRC')}: --</p>
      </div>
    </div>
  );
};

export default VerifyResult;
